import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import PasswordResetsContainer from './PasswordResetsContainer'
import {resetPassword} from './actions'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetching: state.models.user.isFetching,
    formErrorMessage: state.models.user.formErrorMessage,
    title: state.models.user.title
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleOnSubmit: (email)=> {
      return dispatch(resetPassword(email)).then(response => response)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetsContainer)



// WEBPACK FOOTER //
// ./src/user/PasswordResetsPage.js